{
  "name": "22-Sruti (Sambamurthy/Daniélou)",
  "description": "22-tone Quintal Rational Intonation Indian śruti gamut, according to Sambamurthy/Daniélou, consisting of 22 notes per octave derived from harmonic partial row intervals up to a prime limit of 5. Derived by schisma-alteration from a 22-tone 3-Limit scale generated from 11 perfect fifths ascending and 10 descending plus the fundamental. Notated with Indian syllable names.",
  "scale": [
    "256/243",
    "16/15",
    "10/9",
    "9/8",
    "32/27",
    "6/5",
    "5/4",
    "81/64",
    "4/3",
    "27/20",
    "45/32",
    "64/45",
    "3/2",
    "128/81",
    "8/5",
    "5/3",
    "27/16",
    "16/9",
    "9/5",
    "15/8",
    "243/128",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "22-JI-5L_Srutis",
  "built_in_group": "Indian Theoretical Systems",
  "key_labels": "note_names",
  "note_names": [
    " Sa ",
    " ReL- ",
    " ReL+ ",
    " Re- ",
    " Re ",
    " GaL ",
    " Ga♭ ",
    " Ga ",
    " Ga+ ",
    " Ma ",
    " Ma+ ",
    " MaL- ",
    " MaL+ ",
    " Pa ",
    " DhaL ",
    " Dha♭ ",
    " Dha ",
    " Dha+ ",
    " NiL ",
    " Ni♭ ",
    " Ni ",
    " Ni+ "
  ],
  "note_colors": [
    "#ffc8c8",
    "#d0d0d7",
    "#dee2da",
    "#fffae5",
    "#ffffff",
    "#d0d0d7",
    "#dee2da",
    "#fffae5",
    "#ffffff",
    "#ffffff",
    "#dee2da",
    "#fffae5",
    "#dee2da",
    "#ffffff",
    "#d0d0d7",
    "#dee2da",
    "#fffae5",
    "#ffffff",
    "#d0d0d7",
    "#dee2da",
    "#fffae5",
    "#ffffff"
  ],
  "equivSteps": 22,
  "fundamental": 440,
  "reference_degree": 17,
  "center_degree": 0,
  "rSteps": 4,
  "drSteps": 1,
  "hexSize": 42,
  "rotation": -16.102113751
}
